import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import isProduction from "~/utils/isProduction";

export default function GoogleAnalytics({ propertyId }: { propertyId?: string }) {
  const location = useLocation();

  useEffect(() => {
    if (!propertyId) return
    ReactGA.initialize(propertyId);
  }, [propertyId]);

  useEffect(() => {
    if (!propertyId) return
    if (!isProduction) return

    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
};